module.exports = __webpack_public_path__ + "img/EDICTOSMOV.16b00d91.svg";